import { getLogoutReasonFromError, type LogoutReason } from './authTypes'

export type RefreshResult = { ok: true } | { ok: false; logoutReason?: LogoutReason }

let refreshInFlight: Promise<RefreshResult> | null = null

async function performRefresh(): Promise<RefreshResult> {
	try {
		const refreshResponse = await fetch('/api/auth/refresh', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: '{}',
		})

		if (!refreshResponse.ok) {
			const errorData = await refreshResponse.json().catch(() => null)
			const logoutReason = errorData ? getLogoutReasonFromError(errorData) : undefined
			return { ok: false, logoutReason }
		}
		window.dispatchEvent(new CustomEvent('tokens-refreshed'))
		return { ok: true }
	} catch {
		return { ok: false }
	}
}

export function refreshAccessToken(): Promise<RefreshResult> {
	if (refreshInFlight) {
		return refreshInFlight
	}

	refreshInFlight = performRefresh().finally(() => {
		refreshInFlight = null
	})

	return refreshInFlight
}
